import { render, staticRenderFns } from "./modalModoDigitacaoHora.vue?vue&type=template&id=fb2390c8&scoped=true&"
import script from "./modalModoDigitacaoHora.vue?vue&type=script&lang=js&"
export * from "./modalModoDigitacaoHora.vue?vue&type=script&lang=js&"
import style0 from "./modalModoDigitacaoHora.vue?vue&type=style&index=0&id=fb2390c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2390c8",
  null
  
)

export default component.exports